import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';
import type { ServiceTypeSlug } from '@rover/types/src/ServiceType';

/** The core search surface the person left from. */
export type CoreToSpecialtySource = 'search-wizard-modal' | 'service-type-dropdown';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person leaves core search for training or grooming search while their
 * location is expressed in a form those pages can't represent — a map bounding box.
 * Training and grooming locate a search by center point alone, so such a box can't be
 * carried over even once we start preserving filters across the link. Sizes how often
 * that loss would actually affect someone.
 *
 * Payload: `{ serviceType, source }`
 *
 * &nbsp;
 */
export class CoreToSpecialtySearchUnconvertibleLocation extends AnalyticsEvent {
  eventName = 'core-to-specialty-search-unconvertible-location';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.recommendations.browse_search;

  constructor(eventProperties: { serviceType: ServiceTypeSlug; source: CoreToSpecialtySource }) {
    super(eventProperties, eventProperties);
  }
}
